import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'

import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBXHTApQxC7eBOhAUSi5kiniwnOdztCyKY',
    libraries: 'geometry',
  }
})

Vue.component('GmapCluster', GmapCluster)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
